<!--
 * @FilePath: /net-hall-zj/src/views/Home/Login.vue
-->
<template>
    <div></div>
</template>
<script>
import qs from 'qs';
import { mapGetters } from 'vuex';
import { Toast } from 'vant';
import serverconfig from "@/api/server.config";
// import zwlogQueue from '@/utils/zwlog';
import { setLocalStorage, getLocalStorage } from '@/utils/cache';
import {auth, getToken, getUserBaseInfo} from '@/api/api.js';
import { sm3SignTokenParam, sm3SignUserBaseInfo } from '@/utils/sign';
import { uuid } from 'vue-uuid';
import storage from '@/utils/storage';

const sUserAgent = window.navigator.userAgent.toLowerCase();
// 是否是浙里办支付宝小程序
const bIsAlipayMini = sUserAgent.indexOf('miniprogram') > -1 && sUserAgent.indexOf('alipay') > -1;

export default {
    name: 'Login',
    data() {
        return {
            user: '',
            allToken: '',
            token: '',
            uuid: uuid.v1(),
        };
    },
    computed: {
        ...mapGetters(['loginStatus'])
    },
    created() {
        // 蒙速办统一登录
        this.getToken();

        // 模拟登录
        // this.staticLogin();
    },
    methods: {
        async staticLogin() {
          let res = {
            "status": "complete",
            "errorCode": "200",
            "msg": "success",
            "errorMessage": "success",
            "errorMsg": "success",
            "resultData": {
              "custThirdType": "01",
              "nickName": "Where Did U GO",
              "headPortrait": "https://thirdwx.qlogo.cn/mmopen/vi_32/ZXLibyRlJXxE8iaTbg9nl7JohvQDBOM5BpHib3lAMlvQQ50YGNBhKF6aGiaktkfmWDic31x0fRWJibtAmhehQUw4PKajMql3HEUOMAHkj8y9FVvvQ/132",
              "gender": "0",
              "realName": null,
              "token": "bmV0aGFsbDp3eDpjdXN0Oi9sb2dpbi8xOTQyMDIxNjU4ODAxMTU2MDk3LzE4NzI3MjcwNTIzODU4OTQ0ZmExNjNlY2JiMjRl",
              "userId": "oMqKe5-01-hnKOfs4moC-k2flqjU"
            },
            "currentTime": 1750729348645
          };
          console.log('模拟登录成功', res.resultData);
          let bind = [{"bindId":"0b075082e949535801588b1f9b68cf00","userId":"oMqKe5-01-hnKOfs4moC-k2flqjU","clientCode":"0002000007","customerNo":"0002000007","bindState":"Y","bindGroup":"朋友家","bindTime":"2025-07-15 16:00:49","unbindTime":null,"tenantId":"1904073668020043778","createTime":"2025-07-15 16:00:49","updateTime":"2025-07-15 16:00:49","accountType":"wx","abodeCode":"1907609997873938434","unBindUser":null,"abodeName":"通辽市城市供水有限公司","clientName":"1#1-501兰玉华","clientAddress":"J119-1.新新花园1#1-501(明仁大街南,平安路东)","waterVolume":"0","arreLocalDate":"2025-07","mrStartCode":null,"mrStopCode":null,"balanceFee":28.45,"chargeAmount":0,"clientState":"1","clientScore":null}]
          storage.set('bindInfo', bind);
          storage.set('User-Info',  res.resultData);
          await this.$store.dispatch('user/setUserInfo', res.resultData);
          // await this.$store.dispatch('user/setHomeInfo', res.resultData);
          await this.$store.dispatch('user/setLoginStatus', 2);
          this.$router.push({ path: '/' });
        },
        async getToken() {
          console.log('LOGIN')
          console.log(this.$route)
            // if (this.app_secret === '' || this.app_secret === undefined){
            //     this.$notify.warning("请先填写应用密钥")
            // }
            let time = new Date().getTime()
            let uuid = this.uuid;
            let sign = sm3SignTokenParam({
                app_id: serverconfig.APP_KEY,
                app_secret: serverconfig.APP_SECRET,
                code: this.$route.query.code,
                grant_type: 'authorization_code',
                time: time,
                uuid: uuid,
            })
            getToken(this.$route.query.code, serverconfig.APP_KEY, sign, time, uuid)
                .then(response => {
                    if (response.data.code === 1000){
                        this.allToken = response.data.data;
                        this.token = response.data.data.token;
                        this.getUserBaseInfo();
                    }
                })
        },
        async getUserBaseInfo() {
            let time = new Date().getTime()
            let uuid = this.uuid;
            let sign = sm3SignUserBaseInfo({
                app_id: serverconfig.APP_KEY,
                app_secret: serverconfig.APP_SECRET,
                auth_token: this.token,
                time: time,
                uuid: uuid,
            })
            getUserBaseInfo(this.token, serverconfig.APP_KEY, sign, time, uuid).then(response => {
                if (response.data.code === 1000){
                    this.user = JSON.stringify(response.data.data)
                    // const userNew = await this.$store.dispatch('user/loginWechatAuthNew', loginParam);
                    //         setLocalStorage(userNew.resultData.payUnitCode);
                    //         // 获取绑定表卡
                    //         await this.$store.dispatch('user/getAccountInfo');
                    //         // 获取数据字典
                    //         await this.$store.dispatch('dict/GenerateDictory', userNew.resultData.tenantName);
                    //         await this.$store.dispatch('user/setLoginStatus', 2);
                    //         // 登录埋点
                    //         // aplusQueue();
                    //         zwlogQueue();
                    //         this.$router.push({ path: '/' });
                }
            })
        },
        //单点登录
        // async singleLogin() {
        //     console.log(ZWJSBridge.ssoTicket)
        //     if (ZWJSBridge.ssoTicket) {
        //         const ssoFlag = await ZWJSBridge.ssoTicket({});
        //         console.log(ssoFlag)
        //         if (ssoFlag && ssoFlag.result === true) {
        //             //使用 IRS“浙里办”统一单点登录组件
        //             if (ssoFlag.ticketId) {
        //                 console.log(ssoFlag.ticketId)
        //                 // TODO 应用方服务端单点登录接口
        //                 try {
        //                     let loginParam = { payUnitCode: null, ticket: ssoFlag.ticketId, appId: config.app.miniAppId };
        //                     loginParam.payUnitCode = getLocalStorage();
        //                     const userNew = await this.$store.dispatch('user/loginWechatAuthNew', loginParam);
        //                     setLocalStorage(userNew.resultData.payUnitCode);
        //                     // 获取绑定表卡
        //                     await this.$store.dispatch('user/getAccountInfo');
        //                     // 获取数据字典
        //                     await this.$store.dispatch('dict/GenerateDictory', userNew.resultData.tenantName);
        //                     await this.$store.dispatch('user/setLoginStatus', 2);
        //                     // 登录埋点
        //                     // aplusQueue();
        //                     zwlogQueue();
        //                     this.$router.push({ path: '/' });
        //                 } catch (err) {
        //                     await this.$store.dispatch('user/setLoginStatus', 0);
        //                     Toast.fail('获取用户信息失败!');
        //                 }
        //             }
        //         } else {
        //             //异常情况：当前环境不支持 “浙里办”统一单点登录
        //             // Toast.fail('当前环境不支持 “浙里办”统一单点登录!');
        //             console.log('当前环境不支持 “浙里办”统一单点登录!')
        //         }
        //     } else {
        //         //异常情况：ZWJSBridge 加载异常
        //         console.log('ZWJSBridge 加载异常')
        //     }
        // },
        async handleLoginNew() {
            switch (Number(this.loginStatus)) {
                case 0:
                    {
                        await this.$store.dispatch('user/setLoginStatus', 1);
                        this.singleLogin();
                    }
                    break;
                case 1:
                    {
                        const sp = this.hashKey('sp');
                        let ticket = this.hashKey('ticket');
                        /* 支付宝小程序ticket后存在 #/ 的问题 */
                        if (ticket && ticket.substr(-2) === '#/') {
                            ticket = ticket.slice(0, ticket.length - 2);
                        }
                        console.log(ticket)
                        if (!ticket) {
                            this.singleLogin();
                        } else if (sp && ticket) {
                            let url = decodeURIComponent(sp);
                            if (url.substr(-2) === '#/') {
                                url = url.slice(0, url.length - 2);
                            }
                            const urlParams = qs.parse(url.split('?')[1]);
                            urlParams['ticket'] = ticket;
                            const query = qs.stringify(urlParams);
                            let redirectUrl = `${url.split('?')[0]}?${query}`;

                            location.href = redirectUrl;
                        } else {
                            try {
                                // 获取登录信息并缓存缴费单位
                                let loginParam = { payUnitCode: null, ticket: ticket };
                                loginParam.payUnitCode = getLocalStorage();
                                const userNew = await this.$store.dispatch('user/loginWechatAuth', loginParam);
                                setLocalStorage(userNew.resultData.payUnitCode);
                                // 获取绑定表卡
                                await this.$store.dispatch('user/getAccountInfo');
                                // 获取数据字典
                                await this.$store.dispatch('dict/GenerateDictory', userNew.resultData.tenantName);
                                await this.$store.dispatch('user/setLoginStatus', 2);
                                // 登录埋点
                                // aplusQueue();
                                // zwlogQueue();
                                this.$router.push({ path: '/' });
                            } catch (err) {
                                await this.$store.dispatch('user/setLoginStatus', 0);
                                Toast.fail('获取用户信息失败!');
                            }
                        }
                    }
                    break;

                default:
                    {
                        if (bIsAlipayMini) {
                            my.navigateBack();
                        } else {
                            // ZWJSBridge.close();
                            iCityBridge.close();
                        }
                    }
                    break;
            }
        },
      
        /* 拼接跳转中间地址 */

        /* 获取url中的值 */
        hashKey(key) {
            const url = window.location.href;
            const urlParams = qs.parse(url.split('?')[1]);
            const keyValue = urlParams[key];
            if (keyValue) {
                return keyValue;
            } else {
                return null;
            }
        }
    }
};
</script>
